// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Rl-z","tupacHeader":"Sl-z","tupacHeader2":"Tl-z","tupacMenu":"Ul-z","tupacMenu2":"Vl-z","tupacMain":"Wl-z","tupacMain2":"Xl-z"};